import React, { ReactElement } from 'react';

import { getClassNames } from '../../utils/util';

import useTheme from '../../hooks/use-theme/useTheme';

import PASTLogo from '../../resources/images/logo-blue.png';
import { ReactComponent as PPSLogo } from '../../resources/icons/pps/logo-white.svg';

import './auth-layout.scss';

interface Props extends React.PropsWithChildren<unknown> {
  smallLogo?: boolean;
}

const AuthLayout = ({ children, smallLogo }: Props): ReactElement => {
  const { pps } = useTheme();

  return (
    <div className={getClassNames('auth-layout', { pps })}>
      <div className="auth-layout__content">
        <div className={getClassNames('auth-layout__card', { pps })}>
          <div className="auth-layout__logo-container">
            {pps ? (
              <PPSLogo className={getClassNames('auth-layout__logo', { small: smallLogo, pps })} />
            ) : (
              <img
                className={getClassNames('auth-layout__logo', { small: smallLogo })}
                src={PASTLogo}
                alt="PASTime App Logo"
              />
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
